import { api } from 'api/api';
import { Endpoints } from 'api/constants';
import { ISupplier } from 'types/income';
import { TableDataResponse } from 'types/general';
import { SuppliersFilters } from './suppliers.types';

interface GetSuppliers {
  filters: Partial<SuppliersFilters>;
}

export const loaders = {
  getSuppliers: ({ filters }: GetSuppliers) => {
    return api<TableDataResponse<ISupplier>>({
      url: Endpoints.clientAdmin.suppliers.root,
      params: {
        page: filters.page,
        pageSize: filters.pageSize,
        filter: {
          name: filters.name || undefined,
          systemName: filters.systemName || undefined,
          status: filters.status,
        },
      },
    });
  },
};
